import { Button, SxProps, Theme } from "@mui/material";
import { FC, PropsWithChildren } from "react";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, redMui } from "@ryde/theme";

export interface IMenuButton extends PropsWithChildren {
  text?: string | null;
  labelGray?: string;
  labelRed?: string;
  labelBlue?: string;
  labelBlack?: string;
  iconAlert?: boolean;
  imageAfterText?: boolean;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  disabled?: boolean;
  e2eDataValue?: string;
}

const MenuButtonContentStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "menu-button-content",
})`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  gap: 8px;
  margin-inline-start: 3px;
  margin-inline-end: 3px;
  height: 26px;
  span {
    color: ${blueGreyMui._400};
    margin-inline-start: 3px;
    font-weight: 400;
    font-size: 14px;
    text-transform: none;
  }
  label.gray_number {
    color: ${blueGreyMui._400};
  }
  label.red_number {
    color: ${redMui.A700};
  }
  svg {
    margin-inline-start: auto;
  }
`;

export const MenuButton: FC<IMenuButton> = ({
  children,
  text,
  labelGray,
  labelRed,
  sx,
  imageAfterText = false,
  onClick,
  disabled,
  e2eDataValue,
}) => {
  const sxProps = {
    ...{ px: "4px", borderColor: "grey.300", width: "100%" },
    ...sx,
  };
  return (
    <Button
      onClick={onClick}
      className="filter-menu-button"
      data-e2e="menu_button"
      data-e2e-value={e2eDataValue || ""}
      variant="outlined"
      size="small"
      color="secondary"
      sx={sxProps}
      disabled={disabled}
    >
      <MenuButtonContentStyled className="menu-button-wrapper">
        {!imageAfterText && children}
        {!!text && <span className="menu-button-text">{text}</span>}
        {!!labelGray && <label className="gray_number">{labelGray}</label>}
        {!!labelRed && <label className="red_number">{labelRed}</label>}
        {!!imageAfterText && children}
      </MenuButtonContentStyled>
    </Button>
  );
};
